if (!customElements.get('main-collection-2-sort')){
  class MainCollection2Sort extends HTMLElement{
    constructor(){
      super();

      this.toggleMenu = this.toggleMenu.bind(this);
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleOptionClick = this.handleOptionClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback(){
      this.sortId = this.dataset.sortId;
      
      this.menu = this.querySelector('[data-sort-menu]');
      this.input = this.querySelector('[data-sort-input]');
      this.label = this.querySelector('[data-sort-label]');
      this.options = this.querySelectorAll('[data-sort-option]');

      this.triggers = document.querySelectorAll(
        `[data-sort-trigger="${this.sortId}"]`
      );

      this.bindEvents();
    }

    disconnectedCallback() {
      this.triggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.toggleMenu);
      });

      this.options.forEach((option) => {
        option.removeEventListener('click', this.handleOptionClick);
      });

      document.removeEventListener('click', this.handleOutsideClick);
    }


    bindEvents() {
      // Multiple triggers
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.toggleMenu);
      });

      // Options
      this.options.forEach((option) => {
        option.addEventListener('click', this.handleOptionClick);
      });

      // Outside click
      document.addEventListener('click', this.handleOutsideClick);
    }

    handleScroll() {
      this.closeMenu();
    }

    closeMenu() {
      this.menu?.classList.add('tw-hidden');
      document.body.classList.remove('!tw-overflow-hidden');

      window.removeEventListener('scroll', this.handleScroll);
    }

    toggleMenu(event) {
      event.stopPropagation();

      const isHidden = this.menu.classList.contains('tw-hidden');
      if (isHidden) {
        this.menu.classList.remove('tw-hidden');
        document.body.classList.add('!tw-overflow-hidden');

        window.addEventListener('scroll', this.handleScroll, {
          passive: true
        });
      } else {
        this.closeMenu();
      }
    }

    handleOptionClick(event) {
      document.querySelector("main-collection-2-sort")?.classList.add("is-loading");
      document.querySelectorAll(".main-collection-2-bottom-bar button[data-sort-trigger]").forEach(trigger => {
        trigger.classList.add("main-collection-2-sort--loading");
      });
      document.documentElement.setAttribute("sort-applied", "true");
      
      const option = event.currentTarget;
      
      const value = option.dataset.value;
      let label = option.dataset.label;
      // if (value == "created-descending"){
      //   label = "New Arrivals"
      // }

      this.input.value = value;

      if (this.label) {
        this.label.textContent = label;
      }

      this.closeMenu();

      // trigger filter form update
      this.closest('form')?.dispatchEvent(
        new CustomEvent('input', {
          bubbles: true,
          cancelable: true,
          detail: {
            data: {
              event: "sort-applied",
              option: option.dataset.value
            }
          }
        })
      );
    }

    handleOutsideClick(event) {
      const clickedTrigger = event.target.closest(
        `[data-sort-trigger="${this.sortId}"]`
      );

      if (
        !this.contains(event.target) &&
        !clickedTrigger
      ) {
        this.closeMenu();
      }
    }
  }
  customElements.define('main-collection-2-sort', MainCollection2Sort);
}